<template>
  <v-app>
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import MainLayout from './components/layouts/MainLayout.vue';
import { eventBus } from './plugins/eventbus';

export default {
  name: 'App',
  components: {
    MainLayout,
  },
  created() {
    eventBus.$on('unauthorized', () => {
      if (this.$router.currentRoute.name !== 'Login') {
        this.$router.replace('/login');
      }
    });
  },
  computed: {
  },
  data: () => ({
    drawer: null,
  }),
  methods: {
  },
};
</script>

<style lang="sass">
  @import "src/styles/app-wide.sass"
</style>
